module.exports = __webpack_public_path__ + "img/solution5_02.37acb27f.jpg";